import { useEffect, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { themeStore } from "./services/themeStore";
import GlobalMobileBottomNav from "./components/feature/GlobalMobileBottomNav";

/** 监听主题 + 路由，仅在纯管理后台（/admin 精确路径）时不应用 dark class
 *  /admin-workspace 是官方工作台，复用用户端模块，需要正常应用 dark class */
function ThemeApplier() {
  const location = useLocation();
  const [theme, setTheme] = useState(() => themeStore.get());

  useEffect(() => themeStore.subscribe(setTheme), []);

  useEffect(() => {
    // 只有纯管理后台（/admin 或 /admin/ 开头但不是 /admin-workspace）才禁用 dark class
    const isAdminBackend =
      location.pathname === '/admin' ||
      location.pathname === '/admin-login' ||
      (location.pathname.startsWith('/admin/') && !location.pathname.startsWith('/admin-workspace'));
    if (theme === 'dark' && !isAdminBackend) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme, location.pathname]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ThemeApplier />
        <AppRoutes />
        {/* 全局底部导航：fixed 定位，zIndex 9999，完全独立于任何页面层叠上下文 */}
        <GlobalMobileBottomNav fixed />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
